export interface IClinique {
  id: string;
  literalReference?: string | null;
  name: string;
  arabicName?: string | null;
  owner?: string | null;
  foundationYear: number;
  address?: string | null;
  arabicAddress?: string | null;
  country?: string | null;
  government?: string | null;
  city?: string | null;
  biography?: string | null;
  arabicBiography?: string | null;
  gps_longitude: number;
  gps_altitude: number;
  photo?: string | null;
  coverPhoto?: string | null;
  website?: string | null;
  postalCode: number;
  email?: string | null;
  mobilePhone1?: string | null;
  mobilePhone2?: string | null;
  fax?: string | null;
  openingTime: number;
  closingTime: number;
  ownerVerified: boolean;
  type: string;
  fixPhone?: string | null;
  state?: string | null;
  listOrder: number;
  departments: any[];
}

export class Clinique implements IClinique {
  id: string;
  literalReference?: string | null;
  name: string;
  arabicName?: string | null;
  owner?: string | null;
  foundationYear: number;
  address?: string | null;
  arabicAddress?: string | null;
  country?: string | null;
  government?: string | null;
  city?: string | null;
  biography?: string | null;
  arabicBiography?: string | null;
  gps_longitude: number;
  gps_altitude: number;
  photo?: string | null;
  coverPhoto?: string | null;
  website?: string | null;
  postalCode: number;
  email?: string | null;
  mobilePhone1?: string | null;
  mobilePhone2?: string | null;
  fax?: string | null;
  openingTime: number;
  closingTime: number;
  ownerVerified: boolean;
  type: string;
  fixPhone?: string | null;
  state?: string | null;
  listOrder: number;
  departments: any[];

  constructor(other?: Partial<IClinique>) {
    this.id = other?.id ?? '';
    this.literalReference = other?.literalReference ?? null;
    this.name = other?.name ?? '';
    this.arabicName = other?.arabicName ?? null;
    this.owner = other?.owner ?? null;
    this.foundationYear = other?.foundationYear ?? 0;
    this.address = other?.address ?? null;
    this.arabicAddress = other?.arabicAddress ?? null;
    this.country = other?.country ?? null;
    this.government = other?.government ?? null;
    this.city = other?.city ?? null;
    this.biography = other?.biography ?? null;
    this.arabicBiography = other?.arabicBiography ?? null;
    this.gps_longitude = other?.gps_longitude ?? 0;
    this.gps_altitude = other?.gps_altitude ?? 0;
    this.photo = other?.photo ?? null;
    this.coverPhoto = other?.coverPhoto ?? null;
    this.website = other?.website ?? null;
    this.postalCode = other?.postalCode ?? 0;
    this.email = other?.email ?? null;
    this.mobilePhone1 = other?.mobilePhone1 ?? null;
    this.mobilePhone2 = other?.mobilePhone2 ?? null;
    this.fax = other?.fax ?? null;
    this.openingTime = other?.openingTime ?? 0;
    this.closingTime = other?.closingTime ?? 0;
    this.ownerVerified = other?.ownerVerified ?? false;
    this.type = other?.type ?? 'CLINIC';
    this.fixPhone = other?.fixPhone ?? null;
    this.state = other?.state ?? null;
    this.listOrder = other?.listOrder ?? 0;
    this.departments = other?.departments ?? [];
  }

  /**
   * Transforme une réponse brute (ex: JSON API) en instance Clinique
   */
  public static fromResponse(res: any): Clinique {
    if (!res) return new Clinique();

    return new Clinique({
      id: res.id,
      literalReference: res.literalReference,
      name: res.firstName+res.lastName,
      arabicName: res.arabicName,
      owner: res.owner,
      foundationYear: res.foundationYear,
      address: res.address,
      arabicAddress: res.arabicAddress,
      country: res.country,
      government: res.government,
      city: res.city,
      biography: res.biography,
      arabicBiography: res.arabicBiography,
      gps_longitude: res.gps_longitude,
      gps_altitude: res.gps_altitude,
      photo: res.photo,
      coverPhoto: res.coverPhoto,
      website: res.website,
      postalCode: res.postalCode,
      email: res.email,
      mobilePhone1: res.mobilePhone1,
      mobilePhone2: res.mobilePhone2,
      fax: res.fax,
      openingTime: res.openingTime,
      closingTime: res.closingTime,
      ownerVerified: res.ownerVerified,
      type: res.type,
      fixPhone: res.fixPhone,
      state: res.state,
      listOrder: res.listOrder,
      departments: res.departments ?? [],
    });
  }
}
